/**
 * Open outbound links and downloadable files in a new tab.
 *
 * Trello: "PDFs und weiterführende Links in neuem Tab öffnen".
 *
 * Adds target="_blank" + rel="noopener noreferrer" to every <a> that either
 * points at another host (weiterführende Links) or at a downloadable file such
 * as a PDF — regardless of host. Links that already declare a target, in-page
 * anchors, and non-http schemes (mailto:, tel:, javascript:) are left untouched,
 * so the downloads block (which sets its own target) is never double-processed.
 *
 * A visually-hidden "(öffnet in neuem Fenster)" hint is appended to links with
 * visible text so screen-reader users are told a new tab opens — mirroring the
 * mini-calendar / downloads-block pattern. Icon-only links are skipped.
 */

const FILE_EXTENSIONS = /\.(pdf|docx?|xlsx?|pptx?|odt|ods|odp|zip|rar|7z|csv|txt|rtf)$/i

const NEW_WINDOW_HINT = '(öffnet in neuem Fenster)'

// a.protocol / a.hostname / a.pathname are resolved against the document, so
// relative URLs inherit the current host and count as internal.
const isOutbound = (a) =>
    /^https?:$/.test(a.protocol) && a.hostname !== window.location.hostname

const isFileDownload = (a) => FILE_EXTENSIONS.test(a.pathname)

const enhance = (a) => {
    if (a.target) return // an editor-chosen target wins — respect it
    if (!a.getAttribute('href')) return
    if (!isOutbound(a) && !isFileDownload(a)) return

    a.target = '_blank'

    const rel = new Set((a.rel || '').split(/\s+/).filter(Boolean))
    rel.add('noopener')
    rel.add('noreferrer')
    a.rel = [...rel].join(' ')

    // Announce the new tab for AT, but only on links that have visible text
    // (skip icon-only links) and don't already carry the hint.
    if ((a.textContent || '').trim() && !a.querySelector('.js-new-window-hint')) {
        const hint = document.createElement('span')
        hint.className = 'visually-hidden js-new-window-hint'
        hint.textContent = ` ${NEW_WINDOW_HINT}`
        a.appendChild(hint)
    }
}

document.querySelectorAll('a[href]').forEach(enhance)
